<template>
    <div>
        <breadcrumb :routerList="[{to:'/basic/role',title:'用户管理'},{title:'用户授权'}]"/>
         <userdatagrant/>
    </div>
</template>

<script>

    import userdatagrant from '../../components/basic/userdatagrant'
   export default {
       components: {
           userdatagrant
       },
   }
</script>
